"use client";

import { motion } from "framer-motion";
import { Stethoscope, Linkedin, Instagram } from "lucide-react";
import Link from "next/link";

export default function BlogAuthor() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative mt-20 overflow-hidden rounded-3xl border border-emerald-100 bg-gradient-to-br from-white to-emerald-50 p-8 shadow-xl"
    >
      {/* subtle gradient glow */}
      <div className="absolute -top-10 -right-10 h-40 w-40 rounded-full bg-emerald-200/40 blur-3xl" />

      <div className="relative flex flex-col md:flex-row items-center md:items-start gap-6">

        {/* Author Image */}
        <div className="relative">

          <img
            src="/dentist/ayush.png"
            className="w-24 h-24 rounded-full object-cover border-4 border-white shadow-lg"
          />

          {/* verified badge */}
          <div className="absolute -bottom-1 -right-1 bg-emerald-600 text-white p-1.5 rounded-full shadow">
            <Stethoscope size={14} />
          </div>

        </div>

        {/* Author Info */}
        <div className="flex-1 text-center md:text-left">

          <h3 className="text-xl font-bold text-gray-900">
            Dr. Ayush
          </h3>

          <p className="text-sm text-emerald-600 font-medium mt-1">
            Lead Dentist • Pinak Dental Clinic
          </p>

          <p className="text-gray-600 mt-3 leading-relaxed max-w-xl">
            Dr. Ayush is known for delivering comfortable and advanced dental
            treatments. He specializes in root canal therapy, dental implants,
            wisdom tooth removal, and restorative dentistry using modern
            technology and patient-first care.
          </p>


        </div>

        {/* CTA */}
        <div className="mt-4 md:mt-0">

          <Link
            href="/#contact"
            className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-5 py-3 text-white font-semibold shadow hover:bg-emerald-700 transition"
          >
            Book Consultation
          </Link>

        </div>

      </div>
    </motion.div>
  );
}